var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1402 2.26326V0.75349C10.1402 0.62263 9.98977 0.550365 9.88821 0.630443L1.08352 7.5074C1.00872 7.56557 0.948184 7.64007 0.906545 7.7252C0.864907 7.81033 0.843262 7.90384 0.843262 7.99861C0.843262 8.09337 0.864907 8.18689 0.906545 8.27202C0.948184 8.35715 1.00872 8.43164 1.08352 8.48982L9.88821 15.3668C9.99173 15.4468 10.1402 15.3746 10.1402 15.2437V13.734C10.1402 13.6383 10.0952 13.5465 10.021 13.4879L2.98977 7.99958L10.021 2.50935C10.0952 2.45076 10.1402 2.35896 10.1402 2.26326Z",
    fill: "#45505A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.b77bd724ca4c1297443a61c2b6028ae7.svg";
export { ForwardRef as ReactComponent };